export const DAFFODILCARE_PRIMARY_COLOR = "#8DC73F"; //green
export const DAFFODILCARE_SECONDARY_COLOR = "#F6CD3B"; //yellow
export const DAFFODILCARE_TERTIARY_COLOR = "#fff"; //white
export const DAFFODILCARE_PULSE_COLOR = "#77c970" //vibrant green
export const DAFFODILCARE_PRIMARY_LIGHT_COLOR = "#8F71C5" //light purple
export const DAFFODILCARE_HIGHLIGHT_COLOR = "#8F71C5" //light purple